<template>
  <a-layout style="padding-top: 65px;">

    <a-layout-content :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '280px' }">

      <!-- 文档位置: 面包屑 -->
      <a-row :gutter="24">
        <a-breadcrumb separator=">" style="margin:0px 0px 20px 20px;">
          <!-- <a-breadcrumb-item>首页</a-breadcrumb-item> -->
          <a-breadcrumb-item>
            <router-link :to="'/admin/track'">
              路径管理
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>步骤管理</a-breadcrumb-item>
          <a-breadcrumb-item>{{ track.name }}</a-breadcrumb-item>
          <!-- <a-breadcrumb-item>{{ track.description }}</a-breadcrumb-item> -->
        </a-breadcrumb>
      </a-row>

      <!-- 操作按钮 -->
      <a-row :gutter="24">
        <!-- 查询按钮 :model="param" -->
        <a-form layout="inline" style="margin:0px 0px 20px 20px;">
          <a-form-item>
            <a-button type="primary" @click="handleQuery()">
              查询
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="add()">
              新增
            </a-button>
          </a-form-item>
          <a-form-item>
            <!-- 新页面打开 -->
            <router-link :to="'/step?trackId=' + trackId" slots="a" target="_blank">
              <a-button type="primary">
                详情
              </a-button>
            </router-link>
          </a-form-item>
        </a-form>
      </a-row>

      <!-- 步骤列表 -->
      <!-- :row-key="record => record.id" -->
      <a-table :columns="columns" :data-source="steps" :loading="loading">

        <!-- 电子图书 -->
        <template v-slot:ebooks="{ record }">
          <!-- 折叠面板 -->
          <!-- <a-collapse v-model:activeKey="activeKey" v-for="item in record.ebooks" :key="item.id">
            <a-collapse-panel :key="item.id" :header="item.name">
              <p>{{ item.name }}</p>
              <p>{{ item.description }}</p>
            </a-collapse-panel>
          </a-collapse> -->
          <!-- 列表 -->
          <a-list item-layout="horizontal" :data-source="record.ebooks">
            <template #renderItem="{ item }">
              <a-list-item>
                <a-list-item-meta> <!-- :description="item.description" -->
                  <template #title>
                    <a :href="'/doc?ebookId=' + item.id" target="_blank">{{ item.name }}</a>
                  </template>
                  <template #avatar>
                    <a-layout>
                      <a-avatar :src="item.coverUrl" shape="square" :size="48" />
                      <span style="background: white;size: 12px;">序号: {{ item.sort }} </span>
                    </a-layout>
                  </template>
                  <template #description>
                    <span>{{ item.description }}</span>
                    <p>
                      <!-- 编辑 -->
                      <a-button type="primary" size="small" ghost @click="editEbook(record, item)">编辑</a-button>
                      <!-- 删除 -->
                      <!-- <a-button type="primary" size="small" ghost danger style="margin-left: 5px;">删除</a-button> -->
                      <a-popconfirm title="删除后不可恢复，确认删除?" ok-text="是" cancel-text="否"
                        @confirm="handleDeleteEbook(record, item)">
                        <a-button type="primary" size="small" ghost danger style="margin-left: 5px;">删除</a-button>
                      </a-popconfirm>
                    </p>
                  </template>
                </a-list-item-meta>
                <!-- <template #actions>
                  <a key="">edit</a>
                  <a key="">more</a>
                </template> -->
              </a-list-item>
            </template>
          </a-list>
        </template>

        <template v-slot:action="{ record }"><!-- { text, record } -->
          <a-space size="small">
            <a-button type="primary" @click="addEbook(record)">
              <PlusOutlined />电子书
            </a-button>
            <a-button type="primary" @click="edit(record)">
              编辑
            </a-button>
            <!-- 删除 -->
            <a-popconfirm title="删除后不可恢复，确认删除?" ok-text="是" cancel-text="否" @confirm="handleDelete(record.id)">
              <a-button type="primary" danger>
                删除
              </a-button>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>

      <!-- 步骤：模态弹出框-->
      <a-modal title="步骤表单" v-model:open="modalVisible" :confirm-loading="modalLoading" @ok="handleModalOk">
        <a-form :model="step" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <a-form-item label="名称">
            <a-input v-model:value="step.name" :allowClear="true" />
          </a-form-item>
          <a-form-item label="描述">
            <a-input v-model:value="step.description" type="textarea" :allowClear="true" />
          </a-form-item>
          <a-form-item label="序号">
            <a-input v-model:value="step.sort" type="number" :min="1" :max="1000" :allowClear="true" />
          </a-form-item>
        </a-form>
      </a-modal>

      <!-- 电子书：模态弹出框-->
      <a-modal title="电子书表单" v-model:open="modalEbookVisible" :confirm-loading="modalEbookLoading"
        @ok="handleEbookModalOk">
        <a-form :model="ebook" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <a-form-item label="分类">
            <a-cascader v-model:value="categoryIds" :field-names="{ label: 'name', value: 'id', children: 'children' }"
              :options="level1" @change="changeCategory" />
          </a-form-item>
          <a-form-item label="电子书">
            <a-select v-model:value="ebook.id" @change="handleChangeSelect" :allowClear="true">
              <!-- 选择项 -->
              <template v-for="item in ebook.ebooksOption" v-bind:key="item.id">
                <a-select-option :value="item.id">
                  <span>{{ item.name }}</span>&nbsp;&nbsp;
                  <span style="font-size: 12px;color: gray">{{ item.description }}</span>
                </a-select-option>
              </template>
            </a-select>
          </a-form-item>
          <a-form-item label="排序">
            <a-input v-model:value="ebook.sort" type="number" :min="1" :allowClear="true" />
          </a-form-item>
        </a-form>
      </a-modal>

    </a-layout-content>


    <!-- 底部 -->
    <TheFooter></TheFooter>

  </a-layout>

</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import axios from 'axios';
import { message, Modal } from 'ant-design-vue';
import { Tool } from "@/util/tool";
import { useRoute } from "vue-router";
import store from "@/store"
import TheFooter from "@/components/the-footer.vue";

export default defineComponent({
  name: 'AdminStep',
  components: {
    TheFooter
  },
  setup() {
    const route = useRoute();
    console.log("路由：", route);
    console.log("route.path:", route.path);          // /admin/track
    console.log("route.query:", route.query);        // {"trackId": "2"}
    console.log("route.param:", route.params);       // {}
    console.log("route.fullPath:", route.fullPath);  // /admin/track?trackId=2
    console.log("route.name:", route.name);          // AdminTrack
    console.log("route.meta:", route.meta);          // {loginRequire: true}

    // 路径ID
    const trackId = ref(route.query.trackId)
    console.log('trackId', trackId.value)

    const track: any = ref({})
    const loading = ref(false);
    const steps = ref()

    // 折叠面板的展开KEY
    const activeKey = ref([]);

    const columns = [
      {
        title: '序号',
        dataIndex: 'sort',
        width: 80
      },
      {
        title: '名称',
        dataIndex: 'name'
      },
      {
        title: '描述',
        dataIndex: 'description'
      },
      {
        title: '电子书',
        slots: { customRender: 'ebooks' },
        width: 400
      },

      {
        title: 'Action',
        key: 'action',
        slots: { customRender: 'action' }
      }
    ];



    /**
     * 数据查询
     **/
    const handleQuery = () => {
      loading.value = true;
      console.log('handleQuery ...')

      axios.get("/track/detail/" + route.query.trackId).then((response) => {
        loading.value = false;
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          // 为选择树添加一个"无"
          track.value = result.data
          steps.value = result.data.steps
        } else {
          message.error(result.message);
        }
      });

    };

    /**
     * 新增
     */
    const add = () => {
      console.log('add ...')
      modalVisible.value = true;
      modalLoading.value = false;
      step.value = {};       // 步骤数据
    };

    /**
     * 增加电子书
     * @param record 
     */
    const addEbook = (record: any) => {
      console.log('addEbook ...', record)
      modalEbookVisible.value = true
      step.value = record
      stepdIdClick = record.id
      ebookRowId = undefined  // 置空记录ID，修改电子书时再赋值
      ebook.value = {}
      categoryIds.value = []; // 图书分类
    };


    /**
    * 编辑步骤
    * @param record 
    */
    const edit = (record: any) => {
      console.log('edit ...', record)
      modalVisible.value = true;
      modalLoading.value = false;
      step.value = record;
    };


    /**
     * 编辑电子书
     * @param record 
     */
    const editEbook = (record: any, item: any) => {
      console.log('editEbook ...', record, item)

      modalEbookVisible.value = true
      step.value = record
      stepdIdClick = record.id
      ebookRowId = item.rowId   // 电子书在步骤记录表中的主键ID
      ebook.value = Tool.copy(item);
      categoryIds.value = [ebook.value.category1Id, ebook.value.category2Id]
      // 查询一下下拉列表
      queryEbooks(ebook.value.category2Id)
    };

    /**
     * 删除电子书
     * @param record 
     * @param item 
     */
    const handleDeleteEbook = (record: any, item: any) => {
      console.log('handleDeleteEbook ...', record, item)
      console.log('rowId', item.rowId)

      axios.delete("/step/ebook/delete/" + item.rowId).then((response) => {
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          message.success('删除成功')
          // 重新加载列表
          handleQuery();
        } else {
          message.error(result.message);
        }
      });

    };

    /**
     * 删除
     * @param id 
     */
    const handleDelete = (id: number) => {
      console.log('handleDelete ...', id)

      axios.delete("/step/delete/" + id).then((response) => {
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          message.success('删除成功')
          // 重新加载列表
          handleQuery();
        } else {
          message.error(result.message);
        }
      });

    };


    // ------------------------ 步骤表单 ------------------------
    /**
     * 数组，[100, 101]对应：前端开发 / Vue
     */
    const step = ref();
    const modalVisible = ref(false);
    const modalLoading = ref(false);

    const handleModalOk = () => {
      console.log('step', step.value)

      // 校验数据
      if (step.value.name == undefined || step.value.name.trim() == ''
        || step.value.description == undefined || step.value.description.trim() == ''
        || step.value.sort == undefined
      ) {
        message.warning('请补全数据')
        return
      }
      // 设置trackID
      step.value.trackId = trackId

      modalLoading.value = true;
      axios.post("/step/save", step.value).then((response) => {
        modalLoading.value = false;
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          modalVisible.value = false;
          message.success('提交成功')
          // 重新加载列表
          handleQuery();
        } else {
          message.error(result.message);
        }
      });
    };


    // ------------------------ 查询分类 ------------------------

    const level1 = ref();
    let categorys: any;

    /**
     * 查询所有分类
     **/
    const handleQueryCategory = () => {
      console.log('handleQueryCategory ...')
      loading.value = true;
      axios.get("/category/all").then((response) => {
        loading.value = false;
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          categorys = result.data.list;
          console.log("原始数组：", categorys);

          level1.value = [];
          level1.value = Tool.array2Tree(categorys, 0);
          console.log("树形结构：", level1.value);
        } else {
          message.error(result.message);
        }
      });
    };


    /**
     * 分类选择监听
     * @param value 
     * @param selectedOptions 
     */
    const changeCategory = (value: any, selectedOptions: any) => {
      console.log("changeCategory: ", value); //[ 200, 201], undefined
      console.log("changeCategory: ", selectedOptions);
      // 清空电子书列表
      ebook.value.ebooksOption = []
      // 清空电子书ID
      ebook.value.id = undefined

      // 查询电子书
      if (value != undefined) {
        queryEbooks(value[1])
      }
    };

    // 分类对应的电子书
    //let ebooksOption: any = []; // = ref([])

    // 查询分类电子书列表
    const queryEbooks = (category2Id: any) => {
      console.log("queryEbooks", category2Id);

      axios.post("/ebook/list", {
        page: 1,
        size: 1000,
        categoryId2: category2Id,
        status: 1
      }).then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          //ref
          ebook.value.ebooksOption = result.data.list
          console.log('ebooksOption', ebook.value.ebooksOption)
        } else {
          message.error(result.message);
        }
      });

    };


    /**
     * 电子书选择
     * @param value 
     */
    const handleChangeSelect = (value: string) => {
      console.log(`selected ${value}`);
    };

    /**
     * 点击的步骤记录ID
     */
    let stepdIdClick: any;
    let ebookRowId: any;

    // ------------------------ 电子书 表单 ------------------------
    /**
     * 数组，[100, 101]对应：前端开发 / Vue
     */
    const categoryIds = ref();
    const ebook: any = ref({});
    const modalEbookVisible = ref(false);
    const modalEbookLoading = ref(false);
    const handleEbookModalOk = () => {
      console.log('ebook', ebook.value)
      console.log('categoryIds', categoryIds.value)

      // 校验数据
      if (ebook.value.id == undefined
        || ebook.value.sort == undefined
        || categoryIds.value == undefined
      ) {
        message.warning('请补全数据')
        return
      }
      modalEbookVisible.value = true;

      console.log('ebook ===> ', ebook)

      // 封装数据 添加trackId & stepId
      let form: any = {};
      form.trackId = track.value.id
      form.stepId = stepdIdClick
      form.ebookId = ebook.value.id
      form.sort = parseInt(ebook.value.sort)
      form.id = ebookRowId

      console.log('form ===> ', form)

      axios.post("/step/ebook/save", form).then((response) => {
        modalEbookVisible.value = false;
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          modalEbookVisible.value = false;
          message.success('提交成功')
          // 重新加载列表
          handleQuery();
        } else {
          message.error(result.message);
        }
      });
    };


    onMounted(() => {

      handleQuery();

      handleQueryCategory();

    });

    return {
      loading,
      columns,
      trackId,
      track,
      steps,
      step,

      handleQuery,
      add,
      handleDelete,
      addEbook,
      edit,
      editEbook,
      handleDeleteEbook,

      handleModalOk,
      modalVisible,
      modalLoading,

      modalEbookVisible,
      modalEbookLoading,
      handleEbookModalOk,
      ebook,
      level1,
      categoryIds,
      changeCategory,
      handleChangeSelect,
    }
  }
});
</script>

<style scoped>
img {
  width: 50px;
  height: 50px;
}
</style>
